/*
 * サブシステム名：マスタ管理
 * 機能名：区分種別一括編集
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import dolly from '@/rahmen/utils/dolly'

import modals from '@/ddv2.library/modals'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')

export default {
  name: 'MsysKubunShubetsuListEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdNarrowDownTextBox,
    DdEditDialog,
    DdIconButtonWithTooltip,
    DdSelectItemsPerPage
  },
  data: () => ({
    itemsPerPage: 25,
    page: 1,

    modeKengen: 0,
    conditions: { keyNo: null },
    dispKbnFlg: true,
    dispSbtFlg: true,
    rec: {},
    rows: [{}],

    headers: [
      { text: '区分', value: 'kbnSbtKbnNm', align: 'center' },
      { text: '識別コード', value: 'kbnShuruiCd' },
      { text: '名称', value: 'kbnSbtShuruiNm' },
      { text: 'コード値', value: 'code', align: 'center' },
      { text: '表示名', value: 'codeNm' },
      { text: '表示順', value: 'hyojiOrder', align: 'right' },
      { text: '項目１', value: 'komoku1' },
      // { text: '項目２', value: 'komoku2' },
      // { text: '項目３', value: 'komoku3' },
      // { text: '項目４', value: 'komoku4' },
      // { text: '項目５', value: 'komoku5' },
      { text: '表示フラグ', value: 'description' },
      { text: '表示切替', value: 'dispSwitch', sortable: false },
      { text: '反映', value: 'actions', sortable: false },
      { text: '変更状況', value: 'memo' }
    ]
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      kubunshubetsushuruiList: 'DDMasters/msysKubunShubetsuShurui'
    }),
    filteredRows () {
      return this.rows.map((elem) => {
        if (elem.kbnSbtKbn === 'K') {
          elem.kbnSbtKbnNm = '区分'
        } else if (elem.kbnSbtKbn === 'S') {
          elem.kbnSbtKbnNm = '種別'
        }
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.description = elem.hyojiFlg ? '表示中' : '非表示'
        elem.memo = elem.editFlg ? '変更中' : ''
        elem.dispKbnFlg = this.dispKbnFlg
        elem.dispSbtFlg = this.dispSbtFlg
        return elem
      }).filter(function (m) {
        return ((m.kbnSbtKbn === 'K' && m.dispKbnFlg === true) || (m.kbnSbtKbn === 'S' && m.dispSbtFlg === true))
      }).sort((a, b) => {
        if (a.sbtShuruiCd > b.sbtShuruiCd) { return 1 }
        if (a.sbtShuruiCd < b.sbtShuruiCd) { return -1 }
        return 0
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    // 区分種別種類
    filteredKubunShubetsuShurui () {
      return this.kubunshubetsushuruiList.filter(function (elem) {
        return elem.kbnSbtKbn === 'S'
      }).map(function (elem) {
        elem.value = elem.kbnSbtShuruiCd
        elem.text = elem.kbnSbtShuruiNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.kbnSbtShuruiCd > elem2.kbnSbtShuruiCd) { return 1 }
        if (elem1.kbnSbtShuruiCd === elem2.kbnSbtShuruiCd) { return 0 }
        return -1
      })
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
    this.fetchData()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        searchText: this.searchText
      }
    },
    /**
     * 全件取得 ※初期表示時のみ
     * @returns
     */
    fetchData: function () {
      // /* eslint no-debugger: "warn" */
      // debugger
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/VwCMsysKubunShubetsu/GetAll')
          .then((data) => {
            this.rows = data.payload
            this.cloneRows = dolly.clone(this.getCloneTargetMethod())
          })
      })
    },
    /**
     * 更新後の再取得 ※対象行のデータとClone情報を差し替える
     * @param {} recId
     * @param {*} rowIndex
     * @returns
     */
    getData: function (recId, rowIndex) {
      // サマリメッセージ初期化
      this.clearSummaryMessage()

      this.conditions.keyNo = this.rec.keyNo
      return new Promise((resolve) => {
        this.HttpClient
          .post('/api/v1/VwCMsysKubunShubetsu/FindByKeyNo', this.conditions)
          .then((data) => {
            this.rec = data.payload
            // 取得データを差し替え
            this.rec.editFlg = false
            this.rec.memo = ''

            Object.assign(this.rows[rowIndex], this.rec)
            // CloneData更新
            this.cloneRows = dolly.clone(this.getCloneTargetMethod())
            // 画面への再描写 ※強制発火用にspliceを実行
            this.rows.splice()
          })
      })
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstshubetsu', 'msyskubunshubetsushurui'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstShubetsuList.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstShubetsuList.savedInputRestorePromise', c)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstShubetsuList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstShubetsuList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            this.$nextTick(function () {
              this.onSearchButtonClick()
            })
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstShubetsuList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstShubetsuList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            // 新規作成ボタンの制御
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onEditClose: function (e, row) {
      if (e === true && !this.isNullValue(row.value)) {
        const index = this.rows.indexOf(row.item)
        this.rec = Object.assign({}, row.item)

        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.isChanged(this.rec, this.cloneRows.rows[index])) {
          this.rec.editFlg = true
        } else {
          this.rec.editFlg = false
        }

        Object.assign(this.rows[index], this.rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onEditCloseNum: function (e, row) {
      // /* eslint no-debugger: "warn" */
      // debugger
      if (e === true && isFinite(this.getNullValue(row.value))) {
        const index = this.rows.indexOf(row.item)
        this.rec = Object.assign({}, row.item)

        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.isChanged(this.rec, this.cloneRows.rows[index])) {
          this.rec.editFlg = true
        } else {
          this.rec.editFlg = false
        }

        Object.assign(this.rows[index], this.rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onSwitchDisplay: function (item) {
      const index = this.rows.indexOf(item)
      this.rec = Object.assign({}, item)
      this.rec.hyojiFlg = !this.rec.hyojiFlg

      // 変更フラグ判定（≠Clone値は変更有とみなす）
      if (this.isChanged(this.rec, this.cloneRows.rows[index])) {
        this.rec.editFlg = true
      } else {
        this.rec.editFlg = false
      }

      Object.assign(this.rows[index], this.rec)
    },
    onCancel: function (item) {
      // サマリメッセージ初期化
      this.clearSummaryMessage()

      const index = this.rows.indexOf(item)
      this.rec = Object.assign({}, item)
      this.rec = this.cloneRows.rows[index]
      this.rec.editFlg = false
      Object.assign(this.rows[index], this.rec)
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },
    onSave: function (item) {
      const p = modals.showConfirm
      p('COMQ0011').then((ok) => {
        if (ok === false || ok === undefined) { return }

        const index = this.rows.indexOf(item)
        this.rec = Object.assign({}, item)

        const self = this
        const opt = {
          registerRequestPromise: self.registerPromise,
          registerResponsePromise: (data) => {
            return new Promise(resolve => {
              // 更新後に自レコードのみ再取得
              this.getData(this.rec.keyNo, index)
              resolve()
            })
          },
          getIdMethod: () => {
            return self.rec.id
          },
          continuousInputInitializePromise: (id) => {
            return new Promise(resolve => {
              resolve()
            })
          },
          getTransitionBackParams: function () {
            return {
              actionId: 0
            }
          },
          isUpdateModeMethod: function () {
            return true
          },
          isNoRefreshModeMethod: function () {
            return true
          },
          isNoMessageModeMethod: function () {
            return true
          },
          getSavedInputMethod: function () {
            return true
          }
        }
        this.register(opt)
      })
    },
    registerPromise: function () {
      // 登録/更新処理実行
      // 自レコードのみを更新する
      let rtn
      if (this.rec.kbnSbtKbn === 'K') {
        rtn = this.HttpClient.put(`/api/v1/MsysKubun/Update?id=${this.rec.id}`, this.rec)
      } else {
        // 種別用のjson変換
        this.rec.sbtShuruiCd = this.rec.kbnShuruiCd
        this.rec.sbtCd = this.rec.code
        this.rec.sbtNm = this.rec.codeNm
        rtn = this.HttpClient.put(`/api/v1/MstShubetsu/Update?id=${this.rec.id}`, this.rec)
      }
      return rtn
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },
    onCsvButtonClick: function (e) {

    },
    setRowColorClass: function (item) {
      return item.editFlg === true ? 'cellBackgroundColorGreen' : ''
    },
    // --------------------------------------------------
    // 共通関数
    // --------------------------------------------------
    isChanged: function (a, b) {
      if (a.code !== b.code || a.codeNm !== b.codeNm || a.hyojiOrder !== b.hyojiOrder || a.komoku1 !== b.komoku1 || a.hyojiFlg !== b.hyojiFlg) {
        return true
      } else {
        return false
      }
    },
    // Nullをゼロに変換(カンマ除去も)
    isNullValue (inputValue) {
      if (inputValue === null) { return true }
      if (inputValue === undefined) { return true }
      if (inputValue === '') { return true }
      return false
    },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return 0 }
      if (inputValue === undefined) { return 0 }
      if (inputValue === '') { return 0 }
      return this.removeComma(inputValue)
    },
    removeComma: function (num) {
      if (!num) { return }

      if (window.isFinite(num) === true) {
        return num
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    }
  }
}
